function Hs_modal_notification(message = '', description = '', slideData = {}) {
  if (message && description) {
    function createElement(element = 'div') {
      return document.createElement(element);
    };

    if (document.querySelector('#hs-notify-modal')) {
      document.querySelector('#hs-notify-modal').remove();
    };

    if (document.querySelector('#hs-modal-css')) {
      document.querySelector('#hs-modal-css').remove();
    };

    var styleModal = createElement('style');
    styleModal.setAttribute('id', 'hs-modal-css');
    styleModal.innerHTML = `
      #hs-notify-modal[data-modal="true"] .hs-notify-modal.hs-modal-is-visble {\
        opacity: 1;\
      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-modal {\
        -webkit-transition: opacity .25s ease-in-out;\
        -moz-transition: opacity .25s ease-in-out;\
        -ms-transition: opacity .25s ease-in-out;\
        -o-transition: opacity .25s ease-in-out;\
        transition: opacity .25s ease-in-out;\
        display: flex;\
        position: fixed;\
        inset: 0;\
        align-items: center;\
        justify-content: center;\
        opacity: 0;\
        z-index: 2147483647;\
        background: rgba(0,0,0,.4);\
        padding: 20px 10px;\
      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-modal.hs-modal-is-visble .hs-notify-modal-dialog {\
        -webkit-transform: scale(1);\
        -moz-transform: scale(1);\
        -ms-transform: scale(1);\
        -o-transform: scale(1);\
        transform: scale(1);\
        opacity: 1;\
      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-modal .hs-notify-modal-dialog {\
        display: -moz-flex;\
        display: flex;\
        -webkit-flex-flow: column nowrap;\
        -moz-flex-flow: column nowrap;\
        -ms-flex-flow: column nowrap;\
        flex-flow: column nowrap;\
        -webkit-box-pack: start;\
        -ms-flex-pack: start;\
        -webkit-justify-content: flex-start;\
        -moz-justify-content: flex-start;\
        justify-content: flex-start;\
        -webkit-transform: scale(0);\
        -moz-transform: scale(0);\
        -ms-transform: scale(0);\
        -o-transform: scale(0);\
        transform: scale(0);\
        -webkit-transition: all .15s ease-in-out;\
        -moz-transition: all .15s ease-in-out;\
        -ms-transition: all .15s ease-in-out;\
        -o-transition: all .15s ease-in-out;\
        transition: all .15s ease-in-out;\
        opacity: 0;\
        margin: auto;\
        border: solid 1px ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_border_color_hex : '#e5e5e5'};\
        border-radius: 6px;\
        box-shadow: 0 5px 15px rgba(0,0,0,.2);\
        background:  ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_background_color_hex : '#ffffff'};\
        width: 100%;\
        max-width: 600px;\
      }\
 
      #hs-notify-modal[data-modal="true"] .hs-notify-modal .hs-notify-header {\
        -webkit-flex: 0 0 auto;\
        -moz-flex: 0 0 auto;\
        -ms-flex: 0 0 auto;\
        flex: 0 0 auto;\
        -webkit-box-flex: 0;\
        -moz-box-flex: 0;\
        display: block;\
        padding: 20px 20px 0;\
        text-align: left;\
        line-height: 1.6;\
        color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_color_text_hex : '#000000'};\
        font-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_font_weigth : '600'};\
        font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_font_size : '14px'};\
        text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_prod_title_text_transform : 'none'};\

      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-modal .hs-notify-content {\
        -webkit-flex: 1 1 auto;\
        -moz-flex: 1 1 auto;\
        -ms-flex: 1 1 auto;\
        flex: 1 1 auto;\
        -webkit-box-flex: 1;\
        -moz-box-flex: 1;\
        display: block;\
        padding: 20px;\
        overflow: auto;\
        text-align: left;\
        color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_color_text_hex : '#000000'};\
        font-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_font_weigth : 'normal'};\
        font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_font_size : '14px'};\
        text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_var_title_text_transform : 'none'};\
      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-modal .hs-notify-action {\
        -webkit-flex: 0 0 auto;\
        -moz-flex: 0 0 auto;\
        -ms-flex: 0 0 auto;\
        flex: 0 0 auto;\
        -webkit-box-flex: 0;\
        -moz-box-flex: 0;\
        display: box;\
        display: flex;\
        display: -moz-flex;\
        display: flexbox;\
        display: flex;\
        -webkit-flex-flow: row-reverse wrap;\
        -moz-flex-flow: row-reverse wrap;\
        -ms-flex-flow: row-reverse wrap;\
        flex-flow: row-reverse wrap;\
        -webkit-box-pack: start;\
        -ms-flex-pack: start;\
        -webkit-justify-content: flex-start;\
        -moz-justify-content: flex-start;\
        justify-content: flex-start;\
        border-top: solid 1px ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_border_color_hex : '#e5e5e5'};\
        padding: 10px;\
      }\
      #hs-notify-modal[data-modal="true"] .hs-notify-button[data-type="button"] {\
        display: inline-block;\
        min-width: 50%;\
        margin: 10px;\
        width: auto;\
        overflow: hidden;\
        text-overflow: ellipsis;\
        white-space: nowrap;\
        color:  ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_color_hex : '#ffffff'} !important;\
        background: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_background_color_hex : '#000000'} !important;\
        border-color: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_background_color_hex : '#000000'} !important;\
        border-width: 2px;\
        border-radius: 5px;\
        cursor: pointer;\
        box-shadow: none;\
        padding: 10px 15px;\
        height: auto;\
        text-align: center;\
        text-transform: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_transform : 'uppercase'} !important;\
        font-weight: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_font_weigth : '600'} !important;\
        font-size: ${typeof slideData.customize !== 'undefined' ? slideData.customize.customize_body_upsell_button_text_font_size : '14px'} !important;\
        outline: none;\
        border-style: solid;\
      }\
    `;
    document.head.appendChild(styleModal);

    var button_text = 'Okay';
    if (typeof slideData.settings !== 'undefined') {
      if (typeof slideData.settings.language_settings !== 'undefined') {
        if (typeof slideData.settings.language_settings.notification_button_text !== 'undefined') {
          button_text = slideData.settings.language_settings.notification_button_text;
        };
      };
    };
    const button_dialog_actions = createElement('button');
    button_dialog_actions.setAttribute('type', 'button');
    button_dialog_actions.classList.add('hs-notify-button');
    button_dialog_actions.setAttribute('data-type', 'button');
    button_dialog_actions.innerHTML = button_text;
    button_dialog_actions.onclick = function () {
      div_noti_modal_visible.classList.remove('hs-modal-is-visble');
      setTimeout(function () {
        div_modal.remove();
        styleModal.remove();
      }, 300);
    };

    const div_dialog_actions = createElement();
    div_dialog_actions.classList.add('hs-notify-action');
    div_dialog_actions.append(button_dialog_actions);

    const div_dialog_content = createElement();
    div_dialog_content.classList.add('hs-notify-content');
    div_dialog_content.innerHTML = description

    const div_dialog_header = createElement();
    div_dialog_header.classList.add('hs-notify-header');
    div_dialog_header.innerHTML = message

    const div_dialog_modal = createElement();
    div_dialog_modal.classList.add('hs-notify-modal-dialog');
    div_dialog_modal.append(div_dialog_header, div_dialog_content, div_dialog_actions);

    const div_noti_modal_visible = createElement();
    div_noti_modal_visible.classList.add('hs-notify-modal')
    setTimeout(function () {
      div_noti_modal_visible.classList.add('hs-modal-is-visble');
    }, 100);

    div_noti_modal_visible.append(div_dialog_modal);

    const div_modal = createElement();
    div_modal.setAttribute("id", "hs-notify-modal");
    div_modal.setAttribute("data-modal", "true");
    div_modal.append(div_noti_modal_visible);

    document.querySelector('body').appendChild(div_modal)
  };
};
function Hs_loading_page_button(element = '', status = '') {
  if (element && status) {
    var submitButton = !!element.closest('product-form') ? element.closest('product-form').querySelector('[type="submit"]') : 0;
    var loading_modal = !!document.querySelector('div.loading-modal.modal') ? document.querySelector('div.loading-modal.modal') : 0;
    if (!loading_modal) {
      if (submitButton) {
        if (status) {
          let type_status = '';
          switch (status) {
            case 'add':
              type_status = 'add'
              break;
            case 'remove':
              type_status = 'remove'
              break;
          }
          if (type_status) {
            //type_status === 'remove' ? submitButton.setAttribute('aria-disabled',true) : submitButton.removeAttribute('aria-disabled');
            submitButton.classList[type_status === 'remove' ? 'add' : 'remove']('loading');
            if (submitButton.querySelector('.loading-overlay__spinner')) {
              submitButton.querySelector('.loading-overlay__spinner').classList[type_status]('hidden');
            }
            if (submitButton.querySelector('.loading__spinner')) {
              submitButton.querySelector('.loading__spinner').classList[type_status]('hidden');
            }
          };
        };
      };
    };
    submitButton = !!element.closest('div.product-form') ? element.closest('div.product-form').querySelector('[type="submit"]') : 0;
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (submitButton.querySelector('.loader-button__loader')) {
            if (type_status === 'remove') {
              submitButton.setAttribute('aria-busy', true);
              submitButton.removeAttribute('hidden');
            } else {
              submitButton.removeAttribute('aria-busy');
              submitButton.setAttribute('hidden', '');
            };
          };
        };
      };
    };

    submitButton = !!element.querySelector('product-buy-buttons-root button.product-buy-buttons--primary') ? element.querySelector('product-buy-buttons-root button.product-buy-buttons--primary') : !!element.closest('product-quick-add.product--quick-add[data-form="false"]') ? element.closest('product-quick-add.product--quick-add[data-form="false"]') : (element.closest('.shop-the-look--products') && element.classList.contains('shop-the-look--add')) ? element : 0;
    //https://genderrevealcelebrations.com/
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (type_status === 'remove') {
            submitButton.setAttribute('aria-busy', true);
          } else {
            submitButton.setAttribute('aria-busy', false);
          };
        };
      };
    };

    submitButton = !!element.closest('buy-buttons.buy-buttons-row') ? element.closest('buy-buttons.buy-buttons-row').querySelector('[type="submit"]') : 0 ||
      !!element.closest('.card__quick-add') ? element.closest('.card__quick-add').querySelector('product-form button[name="add"]') : 0 ||
        !!element.closest('.product-info__block') ? element.closest('.product-info__block').querySelector('product-form [type="submit"]') : 0;
    //https://glance-underwear.com/collections/landing-page/products/3er-pack-schwarz-grau
    //https://www.lesleysophauben.de/
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (type_status === 'remove') {
            submitButton.setAttribute('aria-disabled', true);
            submitButton.classList.add('is-loading');
          } else {
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('is-loading');
          };
        };
      };
    };

    submitButton = !!element.closest('.product-block.appco_bg') ? element.closest('.product-block.appco_bg').querySelector('[type="submit"][data-add-to-cart]') : 0;
    //https://atelierprintworks.com/collections/long-narrow-wall-art/products/olive-branch-framed-canvas-wall-art-print-long-horizontal-art?variant=50087749845322
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (type_status === 'remove') {
            submitButton.classList.add('btn--loading');
          } else {
            submitButton.classList.remove('btn--loading');
          };
        };
      };
    };

    submitButton = !!element.closest('.buy-buttons-row') ? element.closest('.buy-buttons-row').querySelector('.buy-buttons-row .quantity-submit-row [type="submit"]') : 0;
    //https://girltribeco.com/collections/women-all-products
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (type_status === 'remove') {
            submitButton.setAttribute('disabled', 'disabled');
          } else {
            submitButton.removeAttribute('disabled');
          };
        };
      };
    };

    submitButton = !!element.closest('quick-shop-modal.modal.modal-quick-shop.is-open') ? element.closest('quick-shop-modal.modal.modal-quick-shop.is-open').querySelector('.js-form-group button[type="submit"].btn-add-to-cart.js-btn-add-to-cart') : 0;
    //https://bulkbits.com/
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (type_status === 'remove') {
            submitButton.classList.add('pending');
          } else {
            submitButton.classList.remove('pending');
          };
        };
      };
    };
    submitButton = !!element.closest('gp-product[gp-data]:not([gp-data=""])') ? element.closest('gp-product[gp-data]:not([gp-data=""])').querySelector('gp-product-button.gp-product-button gp-button button[type="submit"][data-state]:not([data-state=""])') : 0;
    //https://www.casecue.in/
    //https://enera.co.in/
    if (submitButton) {
      if (status) {
        let dataState = submitButton?.dataset?.state || '';
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status) {
          if (dataState) {
            if (type_status === 'remove') {
              submitButton.dataset.state = 'loading'
            } else {
              submitButton.dataset.state = 'idle'
            };
          };
        };
      };
    };
    submitButton = !!element.closest('.hdt-product-info__item.hdt-product__buy-button') ? element.closest('.hdt-product-info__item.hdt-product__buy-button').querySelector('hdt-buy-buttons.hdt-product-form__buttons button[type="submit"].hdt-product-form__submit') : 0;
    //https://lovechild.in/
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status === 'remove') {
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.setAttribute('disabled', 'disabled');
        } else {
          submitButton.removeAttribute('aria-busy');
          submitButton.removeAttribute('disabled');
        };
      };
    };
    submitButton = !!element.closest('hdt-card-product.hdt-card-product') ? element.closest('hdt-card-product.hdt-card-product').querySelector('.hdt-product-btns button[type="submit"][name="add"]') : 0;
    //https://lovechild.in/
    if (submitButton) {
      if (status) {
        let type_status = '';
        switch (status) {
          case 'add':
            type_status = 'add'
            break;
          case 'remove':
            type_status = 'remove'
            break;
        }
        if (type_status === 'remove') {
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.setAttribute('disabled', 'disabled');
        } else {
          submitButton.removeAttribute('aria-busy');
          submitButton.removeAttribute('disabled');
        };
      };
    };

  };
};

function Hs_modify_result(result = {}, slideData = {}) {
  if (typeof result.items !== 'undefined' && typeof slideData.settings !== 'undefined') {
    try {
      let productStorage = [];
      let show_compare_price = slideData.settings.additional_settings.show_compare_price;
      if (show_compare_price) {
        if (window.localStorage) {
          if (localStorage.getItem("_hsproducts")) {
            productStorage = Hs_CartDrawer.getStorageProducts();
          };
        };
      };

      result.items.forEach(function (item, index) {
        if (productStorage.length > 0) {
          let product = productStorage.filter((prodStorage) => {
            if (item.product_id == prodStorage.id) {
              return prodStorage;
            }
          }) || [];
          if (product.length > 0) {
            let variant = product[0].variants.filter((variant) => {
              if (variant.id == item.id) {
                return variant;
              }
            }) || [];
            if (variant.length > 0) {
              item.compare_at_price = variant[0].compare_at_price;
            };
          };
        };

        var variants_options = '';
        if (item.variant_title !== null) {
          if (!item.product_has_only_default_variant) {
            if (item.options_with_values !== null) {
              if (item.options_with_values.length > 0) {
                item.options_with_values.map((function (e) {
                  let option = e.name.charAt(e.name.length - 1);
                  e.name = option !== ':' ? e.name + ':' : e.name;
                  e.value = e.value.replace(/<.*?>/g, '');
                  variants_options = variants_options.concat(`<div class="hs-cart-item-option" data-hs-cart-item-option-category="${e.name}" data-hs-cart-item-option-value="${e.value}">
                  <span class="hs-variant-option">${e.name} </span>
                  <span class="hs-variant-value">${e.value}</span>
                </div>`);
                }));
              };
            };
          };
        };
        item.variant_title = variants_options;
      });

    } catch (error) {
      console.log(error)
    }
  } else {
    result = false;
  }
  return result;
};

function Hs_hidden_cart_store() {
  let cart_store = [`section#shopify-section-cart-drawer.cart-drawer-section-wrapper`];
  cart_store = document.querySelectorAll(cart_store) || [];
  cart_store.forEach(function (cart) {
    cart.setAttribute("style", "display: none !important,opacity: 0 !important; visibility: hidden !important;");
  });
};

function Hs_couponBar_navs(slideData = {}, top_coupon = 0) {
  if (void 0 !== slideData.coupon_bar) {
    let browser_width = window.innerWidth || 1024;
    let navs = [".site-header.page-element:not(.is-moved-by-drawer)", ".nav-mobile", ".ajaxify-drawer", "#MobileNav:not(.site-header__drawer)", ".header__close.fixed", ".site-header.headroom.headroom--top", "header.hero-active .hero-image-header-wrap", "#nav .wsmenu", "body:not(.scrolled-down) #site-control.site-control", ".nav-shift #page-banner.banner-under-header", ".nav-shift .container #main", "#shopify-section-general-header .main-header-wrapper:not(.sticky-header-scrolled) + .header-drawer", ".mobile_nav-fixed--true .page-banner", ".mobile_nav-fixed--true .page_banner", ".mobile_nav-fixed--false .page_banner", ".tt-desctop-parent-search .tt-dropdown-menu", ".header__search-bar-wrapper.is-fixed", "header#top.scroll-to-fixed-fixed:not(.js-header-sticky--fixed)", ".site-header.has-scrolled", ".site-header#header.header--has-scrolled", ".site-header#header.header--is-standard.header--standard", ".site-header#header.is-standard.header--standard", ".site-header#header.header--is-hamburger.header--standard", ".pageWrap #shopify-section-header nav.nav-hamburger.nav-main", "nav#header-menu.header__drawer.caps.drawer--visible .drawer__content", '#PageContainer .transition-body #shopify-section-header div[data-section-id="header"][data-section-type="header"] #HeaderWrapper.header-wrapper:not(.header-wrapper--sticky)'];
    let coupon_position = slideData.coupon_bar.coupon_bar_position;
    switch (coupon_position) {
      /* case 0:
        break; */
      case 1:
        navs = [".site-header.site-header--homepage.site-header--transparent", "#mobileNavBar", "#StickyBar.sticky--active", ".js-sticky-action-bar .action-area", ".site-header.page-element:not(.is-moved-by-drawer)", ".nav-mobile", ".ajaxify-drawer", ".sticky-navigation-container.sticky.stuck", "#MobileNav:not(.site-header__drawer)", ".header__close.fixed", "#shopify-section-toolbar.toolbar-section", ".site-header-sticky .site-header--stuck", ".nav-container.nav-sticky", "#navbarStickyDesktop.nav-sticky", ".site-header.has-scrolled", ".site-header#header.header--has-scrolled", ".site-header#header.header--is-standard.header--standard", ".site-header#header.is-standard.header--standard", ".site-header#header.header--is-hamburger.header--standard", ".pageWrap #shopify-section-header nav.nav-hamburger.nav-main", ".site-header.headroom", 'body > article.header__section-wrapper[role="banner"] #shopify-section-header.section-header', "#site-header.site-header", 'body[class^="trademark--"] .shopify-section__header', '[data-header-sidebar="true"] .main-sidebar', ".ui.sticky.top", "header.hero-active .hero-image-header-wrap", ".header.sticky .bar.fixed", 'body[class^="kagami--"] #shopify-section-header', "#page header.util", "body:not(.show-mobile-nav) #toolbar.docked", "body.show-mobile-nav #mobile-nav .inner", 'body.show-mobile-nav #mobile-nav #sub-nav-menu-2.sub-nav[data-is-subnav-for="menu-2"]', "#page-wrap-inner > #page-overlay + #page-wrap-content > .section-header", "body.sticky-header .header .header-main-content[data-header-content]", "#nav .wsmenu", ".header_bot.enabled-sticky-menu.sticky", ".\\#header.\\@sticky", ".transition-body #shopify-section-header #NavDrawer.drawer.drawer--is-open", ".transition-body #shopify-section-header #CartDrawer.drawer.drawer--is-open", "#StickyHeaderWrap #SiteHeader.site-header--stuck", ".header__mobile-nav", ".searching .search-bar-wrapper", "#shopify-section-header .coverheader", '#shopify-section-header header.header-section.scrolling[data-sticky="true"]', "#header.mobile-sticky-header--true", "#header.mm-fixed-top.mobile-header.mm-slideout", "#mm-0.mm-page.mm-slideout #header.mobile-header.mobile-sticky-header--false", "#site-control.site-control", ".nav-shift #page-banner.banner-under-header", ".nav-shift .container #main", "body.scrolled-down #pageheader.pageheader.cc-animate-init.cc-animate-complete", "body.scrolled-down #pageheader.pageheader[data-cc-animate]", "body.scrolled-down #pageheader.pageheader.cc-animate-init.cc-animate-complete + .header-search", "body.scrolled-down #pageheader.pageheader[data-cc-animate] + .header-search", "#shopify-section-general-header .main-header-wrapper + .header-drawer", "#shopify-section-general-header.main-header-section", "#shopify-section-general-header nav.drawer-nav.allow-scroll-while-locked[data-drawer-nav]", ".header-section .stuckMenu.isStuck", "header.header__wrapper.js-theme-header.stickynav.sticky--active", "#shopify-section-mobile-navigation .shifter-navigation", ".header-wrapper .sticky-header-wrapper.sticky", "#mobile-header #mobile-nav.mobile-nav", "header.is-sticky.st-visible", 'header#top.header:not([role="banner"])', "header#velaHeader.velaHeader", "body.fixed-header.fixed-header--all > header", ".have-fixed .nav-bar", ".header-bottom.on .header-panel", ".have-fixed .nav-search", ".mb-fixed .hd_mobile", ".open-mn .hd_mobile .icon-menu, .open-user .close_user", "html.open-mn .mn_mobile nav, html.open-user .mobile_customer nav", "#sticky-wrapper.sticky-wrapper.is-sticky .wrapper-header-bt", "#sticky-wrapper.sticky-wrapper.is-sticky .header-bottom[data-sticky-mb]", "body > .body-content-wrapper > .shopify-section-group-header-group.section-header-navigation.shopify-section-header-sticky", "body > .body-content-wrapper > .shopify-section-group-header-group.section-header-mobile.shopify-section-header-sticky", "body > #navigation-mobile.halo-sidebar.halo-sidebar_menu", ".header__search-bar-wrapper.is-fixed", ".sticky-header.header-clone.act-scroll", ".sticky-header-prepared.basel-top-bar-on .header-shop.act-scroll", ".mobile_nav-fixed--false .page_banner", ".header-container.sticky-header", ".tt-stuck-nav.stuck", ".tt-mobile-header-inline-stuck.stuck", "header#top.scroll-to-fixed-fixed", "header#header .header__content--sticky", ".header--sticky.is-sticky .header__content", ".stickyNav", "#header-phantom.sticky-header.fixed-header", "#sticky-info-product-template", ".sticky-wrapper.is-sticky .header-sticky", ".header__mobile.is-fixed", "#shopify-section-header-sticky.header-sticky__placeholder", "header#header-header.site-header", "#shopify-section-pxs-announcement-bar + #shopify-section-header .main-header-wrapper", ".sticky-header #PageContainer #shopify-section-header.header-section", ".header-content .header-container.header-fixed .header-main", ".header-content .header-container.header-mobile-fixed .header-main", "body.site-header-sticky .site-header.site-header-sticky--scrolled", "body.site-header-sticky .site-header.site-header-nav--open", "body.site-header-sticky .site-header", "#app-header.sticky-on.sticky", ".mm-page.mm-slideout #content_wrapper + .mobile-search", ".docked-navigation-container .docked-navigation-container__inner", ".docked-mobile-navigation-container .docked-mobile-navigation-container__inner", 'nav.navigation--sticky.navigation[aria-label="Primary Navigation"]', ".site-header .header-bottom .header-mb.fixed", ".kalles_2-0 #ntheader.live_stuck .ntheader_wrapper", "#header.jsheader_sticky.menu_scroll_v1", ".contentbody .menu_moblie.menu_mobilescroll", ".site-header-wrapper.site-header--sticky", ".body-cont #shopify-section-header > .cont-header.header-fixed-true", "body.cc-animate-enabled[data-cc-animate-timeout] > #shopify-section-header.section-header", "body.cc-animate-enabled[data-cc-animate-timeout].reveal-mobile-nav > .mobile-navigation-drawer", "body.cc-animate-enabled[data-cc-animate-timeout].show-search #main-search.main-search", 'body.has-sticky-header .header__wrapper.js__header__stuck[data-header-sticky="sticky"]', ".header__drawer.drawer--visible[data-drawer] .drawer__content .drawer__inner[data-drawer-inner]", 'div.navbar.w-nav[data-w-id][role="banner"]', '.w-nav-overlay nav.nav-menu.w-nav-menu[data-nav-menu-open][role="navigation"]', "body > .page > #shopify-section-header.header__outer-wrapper", 'body > .page > #shopify-section-header.header__outer-wrapper > header.header[data-is-sticky="true"][data-enable-sticky-header="true"] > .drawer-menu.active.visible', "body > .page > #shopify-section-header.header__outer-wrapper > header.header.is-sticky > .drawer-menu.animation.animation--drawer-menu.active.visible.animation--drawer-menu-revealed", "body.body-with-sticky-header .header-wrapper.header-wrapper--fixed", ".featured-collections__header.sticky__element.featured-collections__header", ".container > .container__top-part .page__header.page__header--sticky", '.pageWrap > #shopify-section-announcement + #shopify-section-header.shopify-section.shopify-section-header header.site-header[data-section-id="header"][data-section-type="header"][data-header-height][data-scroll-lock-fill-gap]', '.page-wrap > #shopify-section-announcement + #shopify-section-header.shopify-section.shopify-section-header header.site-header[data-section-id="header"][data-section-type="header"][data-header][data-header-height][data-scroll-lock-fill-gap]', '#MainContent header.header-sticky .header[data-header-settings*="true"]', ".\\#main-header.\\@sticky .\\#main-nav-container", ".\\#main-header.\\@sticky .\\#main-header-inner", ".js__header__stuck.js__header__stuck__backdrop[data-underline-current] .theme__header", 'section.sf-header.stuck[data-section-id="header"][data-section-type="header"] .header__wrapper.absolute', "body.site-header-sticky #shopify-section-static-header.shopify-section.site-header-wrapper > section.site-header.site-navigation-layout-expanded[data-header-main]", "body.site-header-sticky #shopify-section-static-header.shopify-section.site-header-wrapper > section.site-header.site-navigation-layout-drawer[data-header-main]", "body > #shopify-section-header.shopify-section.shopify-section-header-sticky.animate:not(.shopify-section-header-hidden)", 'body > #header[data-section-id="header"][data-section-type="header-section"].stickyHeader', "body > .shopify-section.shopify-section-group-header-group.section-header.shopify-section-header-sticky:not(.shopify-section-header-hidden)", 'html[style*="--header-offset: 0px;"] body > #wrapper > .header-section > header#header.header-sticky--active', "body.has-scrolled .site-header--fixed", ".container > .header-group > .shopify-section.shopify-section-group-header-group.page-header > .header__wrapper.js__header__stuck", ".header_group.sticky-ann", ".header_group.sticky-ann > .shopify-section.shopify-section-group-header-group.scrolled-past-header", "#shopify-section-header.shopify-section section.header-kaj .header-area.is-sticky", '#shopify-section-header.shopify-section .modal.fade#seachmodal[aria-modal="true"]', 'body > .shopify-section.shopify-section-group-header-group.section-header header-search #search-form.bls__drawer.open', 'html.nav-open > body > .shopify-section.shopify-section-group-header-group.section-header header header-inner .header__menu nav.navigation.horizontal', 'header.site-header.site-header-nav--open > .site-mobile-nav#site-mobile-nav[data-open="true"]', 'header height-observer:not([variable="header"]) x-header.header.is-solid', 'header-sidebar#sidebar-menu.drawer[open]::part(base)', 'html.open_show.open_menu #shopify-section-mobile_menu.shopify-section .js-menu-mobile-content', 'header.header-area[data-section="HeaderSection"] .header-main-area .main-menu-area.sticky.is-sticky', 'header.header-area[data-section="HeaderSection"] .mobile-header.d-lg-none.sticky.is-sticky', 'header.header-area[data-section="HeaderSection"] aside.off-canvas-wrapper.open .off-canvas-inner-content', 'body >.sticky-header.show', 'body > .shopify-section.shopify-section-group-header-group.site-header-container.mount-header sidebar-drawer#site-menu-sidebar.sidebar.sidebar--opened'];
        browser_width <= 480 && navs.push("#ajaxifyModal");
        browser_width < 650 && navs.push("#shopify-section-header #header.header__wrapper .header__content");
        browser_width <= 720 && navs.push("body.is-mobile header.main-header.no-border[data-header]", "body.is-mobile header.main-header[data-header]");
        browser_width <= 948 && navs.push("#shopify-section-sidebar main-sidebar.sidebar");
        browser_width <= 1080 && navs.push(".navigation.navigation-has-mega-nav");
        800 <= browser_width && navs.push("#nav + #content_wrapper.mm-page .content.container");
        1000 < browser_width && navs.push(".bodywrap.cf .page-header.cf");
        browser_width >= 700 && navs.push('body navigation-drawer.navigation-drawer.drawer#header-sidebar-menu[open]');
        let warehouse_shopify_section_header = document.querySelector('body[class^="warehouse"] #shopify-section-header') || '';
        warehouse_shopify_section_header && getComputedStyle(warehouse_shopify_section_header).position === "sticky" && navs.push('body[class^="warehouse"]#shopify-section-header');
        let announcement_bar_shopify_section_header = document.querySelector('.shopify-section.shopify-section-group-header-group.shopify-section--announcement-bar') || '';
        announcement_bar_shopify_section_header && getComputedStyle(announcement_bar_shopify_section_header).position === "sticky" && navs.push('.shopify-section.shopify-section-group-header-group.shopify-section--announcement-bar');
        let shopify_section_header = document.querySelector('body > header.shopify-section.shopify-section-group-header-group.shopify-section--header') || '';
        shopify_section_header && getComputedStyle(shopify_section_header).position === "sticky" && navs.push('body > header.shopify-section.shopify-section-group-header-group.shopify-section--header');
        let header_shopify_section_header = document.querySelector('body > header#shopify-section-header.shopify-section.shopify-section--header') || '';
        header_shopify_section_header && getComputedStyle(header_shopify_section_header).position === "sticky" && navs.push('body > header#shopify-section-header.shopify-section.shopify-section--header');
    };

    navs = (navs.length && (b = navs.join() + "{top:" + top_coupon + "px !important;}"),
      "");
    document.body.insertAdjacentHTML("beforeend", '<div id="hs_coupon_bar _styles"><style>' + b + "</style></div>");
  };
};

function Hs_dynamic_checkout() {
  let cssCheckout = `.wallet-cart-wrapper .wallet-cart-grid, .wallet-button-wrapper .wallet-cart-grid {
    margin-top: 0 !important;
}

.wallet-cart-grid {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    flex-wrap: wrap !important;
    -webkit-box-orient: horizontal !important;
    -webkit-box-direction: normal !important;
    flex-direction: row !important;
    gap:10px !important;
    /* margin: 15px -5px -15px -5px !important; */
    margin: 15px 0px 0px 0px !important;
}
.wallet-cart-grid.accelerated-checkout-button-container > li.wallet-cart-button-container .wallet-cart-button,.wallet-cart-grid.accelerated-checkout-button-container > div[data-testid="grid-cell"].wallet-cart-button-container .wallet-cart-button{
  width: 100% !important;
}
.wallet-cart-grid>li,.wallet-cart-grid>div[data-testid="grid-cell"] {
    flex-basis: unset !important;
    /* margin: 0 5px 5px !important; */
    margin: 0 !important;
    list-style: none;
    padding-inline-start: unset !important;
    border-radius: calc(3 * 1px);
    overflow: hidden;
}

.hs-payments-empty {
    display: none !important;
    visibility: hidden !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:only-child,
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:only-child {
    flex: 1 1 100% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(2):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(1):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(2):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(1):nth-last-child(2) {
    flex: 1 1 45% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(3):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(2):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(1):nth-last-child(3),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(3):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(2):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(1):nth-last-child(3)  {
    flex: 1 1 28% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(4):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(4):nth-last-child(1) {
    flex: 1 1 100% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(3):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(2):nth-last-child(3),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(1):nth-last-child(4),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(3):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(2):nth-last-child(3),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(1):nth-last-child(4) {
    flex: 1 1 28% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(5):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(4):nth-last-child(2),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(5):nth-last-child(1),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(4):nth-last-child(2) {
    flex: 1 1 45% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(3):nth-last-child(3),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(2):nth-last-child(4),
.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(1):nth-last-child(5), 
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(3):nth-last-child(3),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(2):nth-last-child(4),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(1):nth-last-child(5) {
    flex: 1 1 28% !important;
}

.wallet-cart-grid:not(.hs-payments-empty)>li:nth-child(n),
.wallet-cart-grid:not(.hs-payments-empty)>div[data-testid="grid-cell"]:nth-child(n) {
    flex: 1 1 28% !important;
}`;
  //let cssCheckoutItem = ".accelerated-checkout-button{min-width:unset!important;border-radius:calc(3 * 1px) !important;}"
  let cssCheckoutItem = ".accelerated-checkout-button{min-width:unset!important;}"
  let cssCheckoutSkeleton = "ul.wallet-cart-grid--skeleton{display:none;}"
  function updateStyleElement(t, e, n = "hs-dynamic-checkout-style") {
    if (t) {
      var r = t.querySelector(`#${n}`);
      r || ((r = document.createElement("style")).id = n,
        t.appendChild(r)),
        r.innerHTML = e
    }
  };
  let dynamic_checkout_key = {
    "ShopifyPay-button": "shop-pay",
    "Checkout with PayPal": "paypal",
    "GooglePay-button": "google-pay",
    "ApplePay-button": "apple-pay",
    "AmazonPay-button": "amazon-pay",
    "MetaPay-button": "meta-pay",
    "button-ShopPay": "shop-pay",
    "button-PayPal": "paypal",
    "button-GooglePay": "google-pay",
    "button-ApplePay": "apple-pay",
    "button-MetaPay": "meta-pay",
    "button-AmazonPay": "amazon-pay"
  };
  let payments = [
    "shop-pay",
    "paypal",
    "google-pay",
    "meta-pay",
    "amazon-pay",
    "apple-pay"
  ];
  var slide_cart = document.querySelector('.hs-site-cart-popup-layout') || '',
    hs_additional_buttons = slide_cart ? slide_cart.querySelector('#hs-additional-buttons') : '',
    dynamic_checkout = hs_additional_buttons ? hs_additional_buttons.querySelector(`.dynamic-checkout__content`) : '',
    shopify_accelerated_checkout = dynamic_checkout ? dynamic_checkout.querySelector("shopify-accelerated-checkout-cart") : '',
    shopify_button_container = shopify_accelerated_checkout ? shopify_accelerated_checkout.querySelector('[data-shopify-buttoncontainer="true"]') : '',
    shopify_accelerated_checkout = shopify_accelerated_checkout ? shopify_accelerated_checkout?.wrapper : '';

  shopify_button_container && updateStyleElement(shopify_button_container, cssCheckoutSkeleton);

  shopify_accelerated_checkout && (updateStyleElement(shopify_accelerated_checkout, cssCheckout),
    shopify_accelerated_checkout.querySelectorAll(".wallet-cart-button-container").forEach((wallet_button => {
      var checkout_slot = wallet_button.querySelector("slot")?.getAttribute("name"),
        attribute = dynamic_checkout_key[checkout_slot];
      wallet_button.classList.remove(`hs-payments-empty`),
        wallet_button.style.height = "44px",
        wallet_button.querySelector(".wallet-cart-button").style.height = "44px",
        wallet_button.setAttribute(`hs-payments`, attribute),
        payments.includes(attribute) || dynamic_checkout.classList.add(`hs-payments-empty`)
    }
    ))),
    shopify_accelerated_checkout && ["shop-pay-wallet-button", "shopify-paypal-button", "shopify-google-pay-button", "shopify-apple-pay-button", "shopify-meta-pay-button", "shopify-amazon-pay-button"].forEach((e => {
      updateStyleElement(dynamic_checkout.querySelector(e)?.button, cssCheckoutItem),
        updateStyleElement(dynamic_checkout.querySelector(e)?.container, cssCheckoutItem)
    }
    ))
};

function Hs_get_highest_price(show_base_price_discount, show_compare_price, item) {
  let priceOriginal = item.original_line_price//Hs_CartDrawer.typePrice ? item.original_line_price : item.original_price;
  if (!show_compare_price) {
    return priceOriginal;
  };
  var t, n = function () {
    var e, t;
    return item.compare_at_price && null !== (e = item.selling_plan_allocation) && void 0 !== e && e.compare_at_price ? Math.max(item.compare_at_price, item.selling_plan_allocation.compare_at_price) : item.compare_at_price ? item.compare_at_price : null !== (t = item.selling_plan_allocation) && void 0 !== t && t.compare_at_price ? item.selling_plan_allocation.compare_at_price : null
  }(),
    r = n ? n * item.quantity /* (Hs_CartDrawer.typePrice ? n * item.quantity : n) */ : null;
  let o = priceOriginal > item.final_line_price/* (Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price) */;
  if (Hs_CartDrawer.discount_order_x_item && !o) {
    o = item.total_discount > 0;
  };

  var filter_price = function () {
    var price = priceOriginal;
    if (show_base_price_discount && o) {
      price = priceOriginal;
    } else {
      if (r) {
        price = Math.max(r, priceOriginal);
      }
    }
    return price;
  }();
  return Math.max(filter_price, item.final_line_price/* (Hs_CartDrawer.typePrice ? item.final_line_price : item.final_price) */)
};

function Hs_saving_price(price = 0, compare_price = 0) {
  if (compare_price <= price) {
    return 0;
  };
  return compare_price - price;
};